import { FC } from 'react';

import { useCurrentUser } from '@savgroup-front-common/core/domains/login/useLoginStore';
import { UserAvatar } from '@savgroup-front-common/primitive/components/user-avatar';

import HeaderProfileUserName from '../../../Profile/Menu/HeaderProfileUserName';

export const NavigationDrawerProfile: FC = () => {
  const { firstname: firstName, lastname: lastName } = useCurrentUser();

  return (
    <div
      className="flex w-full items-center gap-3 py-3"
      data-testid="appBar_drawerProfile"
    >
      <UserAvatar
        variant="primary"
        shape="square"
        size="lg"
        fullName={`${firstName || ''} ${lastName || ''}`}
      />
      <div className="min-w-0 flex-1">
        <HeaderProfileUserName />
      </div>
    </div>
  );
};
